import InspectionProfileTableData from "./inspectionProfileTableData";
import generateDefaultProviderPanelRow from "./defaultProviderPanelRow";
import { AccuracyInspectionSupplement } from "@app/projects/results/accuracy/accuracyInspectionSupplement";

const providerTelehealthTypeRowKeys: string[] = [];

/* oxlint-disable sort-keys */
export const generateProviderTelehealthTypeRows = (rowKey: string, title: string, supplements: AccuracyInspectionSupplement<string>[]): InspectionProfileTableData[] => {
  const tableData: InspectionProfileTableData[] = [];

  if (supplements && supplements.length > 0) {
    supplements.forEach((supplement : AccuracyInspectionSupplement<string>, index : number) => {
      const currentRowTitle = index === 0 ? title : "";
      const currentRowKey = `${rowKey}-${index}`;
      providerTelehealthTypeRowKeys.push(currentRowKey);

      tableData.push(generateDefaultProviderPanelRow(currentRowKey, currentRowTitle, null, supplement));
    });
  } else {
    providerTelehealthTypeRowKeys.push(rowKey);
    tableData.push(
      generateDefaultProviderPanelRow(rowKey, title, null, null)
    );
  }

  return tableData;
}

export const getProviderTelehealthTypeRowKeys = () : string[] => providerTelehealthTypeRowKeys;